import React from 'react';
import { 
  DropDownButtonProps 
} from '@progress/kendo-react-buttons/dist/npm/ListButton/models/ListButtonProps';
import {
  DropDownButton,
  DropDownButtonBlurEvent,
  DropDownButtonOpenEvent
} from '@progress/kendo-react-buttons';
import _ from 'lodash';
import DynamicStyleManager from '../../../utility/DynamicStyle';
import {
  ANIMATION_CONTAINER_CLASS
} from '../../../utility/window/WindowManager';

class MenuButton extends React.Component <DropDownButtonProps> {
  private dropDownRef: any;
  private defaultSelector: string = `.${ANIMATION_CONTAINER_CLASS}-shown, .${ANIMATION_CONTAINER_CLASS} > .k-popup`;
  private defaultStyles: { [key: string]: any } = {
    zIndex: 103
  };
  private widthSelector: string = `.${ANIMATION_CONTAINER_CLASS}`;

  private onBlurHandler = (event: DropDownButtonBlurEvent): void => {
    if (_.isFunction(this.props.onBlur)) {
      this.props.onBlur(event);
    }
    DynamicStyleManager.resetStyle(this.defaultSelector);
  };

  /**
   * Handles opening menu button and changing style.
   * @param event
   */
  private onOpenHandler = (event: DropDownButtonOpenEvent): void => {
    if (_.isFunction(this.props.onOpen)) {
      this.props.onOpen(event);
    }
    DynamicStyleManager.findStyle(this.defaultSelector, this.defaultStyles);

    let dropDownEl = this.dropDownRef?.element;
    let popupWidth = dropDownEl?.clientWidth; // note that minimum width of buttons is 75px
    let widthStyle = {
      minWidth: popupWidth + 'px'
    };
    DynamicStyleManager.findStyle(this.widthSelector, widthStyle);
  };

  /**
   * Removes styles from DynamicStyleManager.
   */
  componentWillUnmount(): void {
    DynamicStyleManager.remove(this.defaultSelector);
  }

  /**
   * @inheritDoc
   */
  render(): JSX.Element {
    return (
      <DropDownButton
        {...this.props}
        ref={el => this.dropDownRef = el}
        onOpen={this.onOpenHandler}
        onBlur={this.onBlurHandler}
      />
    );
  }
}

export default MenuButton;
